import { createSlice } from "@reduxjs/toolkit"


let initialState = false

const loaderSlice = createSlice({
    name: 'loaderSlice',
    initialState,
    reducers: {
        startLoader: () => true,
        stopLoader: () => false
    }
})

export const { startLoader, stopLoader } = loaderSlice.actions
export default loaderSlice.reducer